import { createSlice } from "@reduxjs/toolkit";

import { SliceActions } from "../types";
import { Noop } from "store";
import { FileData } from "lib/util";
import * as opt from "lib/opt";

export const InitialFormData: FileData = {
	loading: false,
	file: opt.None(),
	parsed: [],
	duns: opt.None(),
	partNumber: "",
	plants: [],
	releasePlants: [],
	description: "",
	containmentName: "",
	sectors: [],
	sectorTypes: [],
	hasMultipleParts: false,
	containmentInitialHold: opt.None(),
	containmentSubsequentHold: opt.None(),
	uploadContentType: null,
	partNumberRequired: null,
	// used for add serials only
	serialCount: opt.None(),
};

export const FormSlice = createSlice({
	name: "form",
	initialState: null,
	reducers: {
		// all these will be handled by the epic
		newFile: Noop<File[]>(),
		noop: Noop<void>(),
	},
});

export type FormActions = SliceActions<typeof FormSlice>;
